import type { JourneyType } from '~types/navigation';
import { RouteNames } from '~types/navigation';

export const DEFAULT_JOURNEY: JourneyType = 'floor';
export const HOME_ROUTE = RouteNames.BigBrowse;
